import React from 'react'

import { Nullable } from 'types'

export const ValueContext = React.createContext<Nullable<any>>(undefined)
